import { Component, Input,  OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators, SelectMultipleControlValueAccessor } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Fournisseur } from 'src/app/parametrage/core/model/fournisseur';
import { FournisseurService } from 'src/app/parametrage/core/service/fournisseur.service';

@Component({
  selector: 'app-edit-fournisseur',
  templateUrl: './edit-fournisseur.component.html',
  styleUrls: ['./edit-fournisseur.component.css']
})
export class EditFournisseurComponent implements OnInit {

  @Input() fournisseurId;

  fournisseur : Fournisseur;

  form2: FormGroup;
  pressButton:Boolean = false;

  errorMessage:String = null;

  
  
  constructor( private _router: Router,
    private _activatedRoute: ActivatedRoute, 
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _fournisseurService: FournisseurService) 
    { 
      this.createForm();
    }

    createForm() 
    {
        this.form2 = this.fb.group({
          nomFournisseur: [null, Validators.compose([Validators.required])]
        });
    }


    

    ngOnInit() {
      this.getFournisseurById(this.fournisseurId)
    }
  
    
    getFournisseurById(actifId)
    {
         this._fournisseurService.getFournisseurById(actifId)
         .subscribe(
             data => {
               debugger
               this.fournisseur =  data;
             },
             error => {
               console.log(error);
             });
    }
  
    
    edit(): void {
        
      this.spinner.show();
          this._fournisseurService.updateFournisseur(this.fournisseur)
          .pipe(first())
              .subscribe(
                  data => {
                    this.spinner.hide();
                    this.activeModal.close();
                    ;
                  },
                  error => {
                    console.log(error);
                    this.spinner.hide();
              });
    }

}
